import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Descriptions, Tag } from 'antd';
// import data
import {digestModeList, instrumentResolutionOptions, workflowOptions} from '../assets/constants/parameters';
import {databaseList} from '../assets/constants/databases';

class SessionCheckList extends React.Component {
  render(){
    // console.log(this.props);
    const {parameters} = this.props;

    let checklist = enrichParameters(parameters);
    // console.log(checklist);

    return(
      <div>
        <Descriptions title="Session Summary" layout="vertical" column={2}>
         {
          checklist.map((item, index)=>{
            return (
              item.value
              ? <Descriptions.Item key={index} label={item.label}><div css={css`color: #0099e5; font-weight: 600`}>{item.value}</div></Descriptions.Item>
              : <Descriptions.Item label={item.label} key={index}>
                {
                  item.list.map((a,i) =>{
                    return(<div key={i} css={css`color: #0099e5; font-weight: 500`}>{a}</div>)
                  })
                }
                </Descriptions.Item>
            )
          })
         }
        </Descriptions>

        <Descriptions title="Session Info" layout="vertical" column={2}>
          <Descriptions.Item label="SessionID"><p css={css`color: #0099e5; font-weight: 600`}>{this.props.sessID}</p></Descriptions.Item>
          <Descriptions.Item label="Associated Email"><p css={css`color: #0099e5; font-weight: 600`}>{this.props.email}</p></Descriptions.Item>
        </Descriptions>
      </div>
    )
  }
}

export default SessionCheckList;

// this is the data format for rendering <Description />
// const convertedParameters = [
//   {key:"raw", value: null, label: "Raw Files", list: []}, // raw files selected, for UI sync, simple array
//   {key: "selectedRaw", value: null, label: "Selected Raw Files", list: []}, // raw files selected, for backend submission, array of objects
//   {key: "database", value: "mouse", label: "Selected Database", list: null}, // string
//   {key:"varied", value: null, label: "Selected Variable Modifications", list: ["Acetyl (Protein N-term)", "Oxidation (M)"]}, // default variable modifications
//   {key: "fixed", value: null, label: "Selected Fixed Modifications", list: ['Carbamidomethyl (C)']}, // default fixed modifications
//   {key: "enzyme", value: null, label: "Selected Enzymes for Digestion", list: ['Trypsin']}, 
//   {key: "digestMode", value:"0", label: "Selected Digestion Mode", list: null},
//   {key: "isobaricList", value: null, label: "Selected Isobaric Labels", list: []},
//   {key: "isobaricTable", value: null, label: "Isobaric Table", list: []},
//   {key: "selectedIsobaricTable", value: null, label: "Selected Isobaric Table", list: []},
//   {key: "lightIsotope", value: null, label: "Selected Light Isotope Lables", list: []},
//   {key: "mediumIsotope", value: null, label: "Selected Medium Isotope Lables", list: []},
//   {key: "heavyIsotope", value: null, label: "Selected Heavy Isotope Lables", list: []}, 
//   {key: "workflowDefault", value: 'closed search', lable: "Selected Workflow", list: null},
//   {key: "resolutionDefault", value: "High-High", label: "Selected Instrument Resolution", list: null}, 
// ];

// ***
// parameters will have to be processed to for previewing purpose
// this is not the format required for the backend processing
const enrichParameters = (_parameters) => {

  // make a deep clone;
  let parameters = JSON.parse(JSON.stringify(_parameters));

  delete parameters.raw;
  delete parameters.isobaricList;
  delete parameters.isobaricTable;

  let _keys = Object.keys(parameters);

  let arr1 = _keys.filter(getArrayElements, parameters);
  // console.log(arr1);
  let arr2 = _keys.filter(getStringElements, parameters);
  // console.log(arr2);

  let _arr1 = arr1.map(key=>{
    let obj = {};
    obj.key = key;
    obj.value = null;
    // update labels
    obj.label = updateParameterLables(key);
    obj.list = updateParameterList(key, parameters[key]);
    return obj;
  });

  let _arr2 = arr2.map(key=>{
    let obj = {};
    obj.key = key;
    obj.value = updateParameterValues(key, parameters[key]);
    // update labels
    obj.label = updateParameterLables(key);
    obj.list = null;
    return obj;
  })
  return ([..._arr2, ..._arr1]);
}


function getArrayElements(key){
  // console.log(key);
  // console.log(this);
  // console.log(typeof(key));
  // console.log(this[key]);
  return Array.isArray(this[key]); 
}

function getStringElements(key){
  return typeof(this[key]) === 'string';
}

const updateParameterLables = (item) => {

  let label = "Not Available";

  if(item === "raw"){
    label = "Files";
  }else if(item === "selectedRaw"){
    label = "Selected Files";
  }else if(item === "database"){
    label = "Selected Database";
  }else if(item === "varied"){
    label = "Selected Variable Modifications";
  }else if(item === "fixed"){
    label = "Selected Fixed Modifications";
  }else if(item === "enzyme"){
    label = "Selected Digestion Enzymes";
  }else if(item === "digestMode"){
    label = "Selected Digestion Mode";
  }else if(item === "selectedIsobaricTable"){
    label = "Selected Isobaric Labels with Correction Factor Values ";
  }else if(item === "lightIsotope"){
    label = "Selected Light Isotope Lables";
  }else if(item === "mediumIsotope"){
    label = "Selected Medium Isotope Lables";
  }else if(item === "heavyIsotope"){
    label = "Selected Heavy Isotope Lables";
  }else if(item === "workflowDefault"){
    label = "Selected Workflow";
  }else if(item === "resolutionDefault"){
    label = "Selected Instrument Resolution";
  }
  return label;
}

const updateParameterValues = (_key, _value) => {
  let value = "Not Available";

  if(_key === "database"){
    for (let item of databaseList){
      if(_value === item.value){
        value = item.label
      }
    }
  }else if(_key === "digestMode"){
    for (let item of digestModeList){
      if(_value === item.index){
        value = item.name
      }
    }
  }else if(_key === "workflowDefault"){
    if(_value === 'closed search'){
      value = "Closed Search"
    }else if(_value === 'open search'){
      value = "Open Search"
    }else if(_value === 'taxonomy analysis'){
      value = "Taxonomy Analysis"
    }
  }else if(_key === "resolutionDefault"){
    if (_value === 'High-High'){
      value = 'High-High';
    }else if (_value === 'High-Low'){
      value = 'High-Low';
    }
  }
  return value;
}

const updateParameterList = (_key, _list) => {
  // console.log(_list);
  let list = [];
  if(_key === "selectedIsobaricTable"){
    list = _list.map(item => {
      return(<div>
        <span>{item.tags}: </span>
        <span>[-1] {item.minus1}% </span> 
        <span>[-2] {item.minus2}% </span> 
        <span>[+1] {item.plus1}% </span>
        <span>[+2] {item.plus2}% </span>
      </div>)})
  }else if(_key === "selectedRaw"){
    list = _list.map(item => {
      return(<div css={css`
        padding: 5px 0px;
      `}>
        <div>[Name]: <Tag>{item.name}</Tag></div>
        <div>[Experiment]: <Tag>{item.experiment}</Tag> </div>
        <div>[Meta]:
          {
            item.metadata.map((i,x)=><Tag key={x}>{i}</Tag>)
          }
        </div>
      </div>)})
  }else{
    list = [..._list];
  }

  return list;
}